import { Dispatch } from "react";
import store from "../../index";

import { Action, AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { State } from "../State";

export default class ReduxStore implements IReduxStore {
    public getStore(): State {
        return store.getState();
    }
    public getDispatch(): FrendsDispatch {
        return store.dispatch;
    }
}

export interface IReduxStore {
    getStore(): State;
    getDispatch(): FrendsDispatch;
}

export type FrendsDispatch = Dispatch<AnyAction> & ThunkDispatch<State, undefined, Action<any>>;